import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks';
import { Alert, Collapse } from 'reactstrap';

import { validateDate } from '~libs/dayjs';

import { InputProps } from '~components/form-fields';
import Icon, { faTriangleExclamation } from '~components/icon';

import { getHoldPeriods } from '~main/actions/clients';

const FormInputClientHoldCheck = ({ value = {}, id }: InputProps) => {
  const { client_id, date, repeat, repeat_start } = value;
  const dispatch = useAppDispatch();

  const [isOnHold, setIsOnHold] = useState(false);
  const [referenceDate, setReferenceDate] = useState<string | null>(null);

  const determineReferenceDate = () => {
    if (repeat && repeat_start && validateDate(repeat_start)) {
      return repeat_start;
    } else if (!repeat && date && validateDate(date)) {
      return date;
    }
    return null;
  };

  const getClientHoldPeriods = async (clientId: number, date: string) => {
    const { payload } = await dispatch(getHoldPeriods({ client_id: clientId, date }));
    return !!(payload?.data && payload?.data.length > 0);
  };

  useEffect(() => {
    const newReferenceDate = determineReferenceDate();
    setReferenceDate(newReferenceDate);
  }, [date, repeat, repeat_start]);

  useEffect(() => {
    const checkHoldStatus = async () => {
      if (referenceDate && !isNaN(parseInt(client_id))) {
        const onHold = await getClientHoldPeriods(client_id, referenceDate);
        setIsOnHold(onHold);
      } else {
        setIsOnHold(false);
      }
    };

    checkHoldStatus();
  }, [client_id, referenceDate]);

  const isOpen = isOnHold && !isNaN(parseInt(client_id));

  return (
    <Collapse isOpen={isOpen}>
      <Alert
        color="danger"
        className="d-flex align-items-center justify-content-center"
        data-id={id}
        data-cy="client-hold-alert"
      >
        <Icon className="me-2" size="3x" icon={faTriangleExclamation} />
        <div className="fw-bold">Client is On Hold for the selected date.</div>
      </Alert>
    </Collapse>
  );
};

export default FormInputClientHoldCheck;
